import { render } from "./importErrorsModal.vue?vue&type=template&id=3745a675&ts=true"
import script from "./importErrorsModal.vue?vue&type=script&lang=ts"
export * from "./importErrorsModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__